import { HttpError } from './HttpError';

export const isErrorCodeEqual = (error: unknown, code: string) => {
  return error instanceof HttpError && error.code === code;
};
